const transportIdKey = "[transport-id]";
/**
 * Wraps a message in a transport object, if a transport ID is provided.
 */
export function rpcTransportMessageOut(data, options) {
    const { transportId } = options;
    if (transportId != null)
        return { [transportIdKey]: transportId, data };
    return data;
}
/**
 * Determines if a message should be ignored, and if not, returns the message
 * too. If the message was wrapped in a transport object, it is unwrapped.
 */
export function rpcTransportMessageIn(message, options) {
    const { transportId, filter } = options;
    const filterResult = filter?.();
    if (transportId != null && filterResult != null)
        throw new Error("Cannot use both `transportId` and `filter` at the same time");
    let data = message;
    if (transportId) {
        if (message[transportIdKey] !== transportId)
            return [true];
        data = message.data;
    }
    if (filterResult === false)
        return [true];
    return [false, data];
}
